import React, { useState, useEffect } from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';

import { getEtapas } from '~services/EtapaService';

interface Stage {
  order: number;
  name: string;
}

interface Props {
  order: number;     // 1-indexed stage order from iirsa_stage.order
  className?: string;
}

const STAGE_CLASS_BY_INDEX = [styles.perfil, styles.pre, styles.ejec, styles.fin];

function DottedProgress({ order, className }: Props) {
  const [stages, setStages] = useState<Stage[] | null>(null);

  useEffect(() => {
    getEtapas().then((response: any) => {
      if (response.ok && response.data) {
        const sorted = [...response.data]
          .map((e: any) => ({ order: e.order, name: e.name }))
          .sort((a, b) => a.order - b.order);
        setStages(sorted);
      }
    });
  }, []);

  if (!stages) return null;

  const currentStep = order - 1;
  return (
    <div className={`row middle space-between ${styles.container} ${className}`}>
      {stages.map((stage, step) => (
        <div key={stage.order} className={classNames({
          [styles.pastStep]: step < currentStep,
          [styles.currentStep]: step === currentStep,
          [styles.futureStep]: step > currentStep,
          [STAGE_CLASS_BY_INDEX[step]]: !!STAGE_CLASS_BY_INDEX[step],
        })}>
          <div className={styles.tooltip}>{stage.name}</div>
        </div>
      ))}
    </div>
  );
}

export default DottedProgress;
